import { createTypeFilter } from '../type-filter/TypeFilterFactory';
import { getSubTypeName, SUB_TYPE_OBJECTS, SUB_TYPE_VALUES } from './SubTypeHelper';

const FILTER_ID = 'subType';
export const SubTypeFilter = createTypeFilter({
    filterId: FILTER_ID,
    typeObjects: SUB_TYPE_OBJECTS,
    typeValues: SUB_TYPE_VALUES,
    getTypeNameFn: getSubTypeName,
    isAllowSelectionEmpty: false,
});
export default SubTypeFilter;
